// src/hooks/useEventPaywall.ts

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useEventPaywall(eventId: string | undefined) {
  const [unlocked, setUnlocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [anonymousLink, setAnonymousLink] = useState<string | null>(null);

  useEffect(() => {
    if (!eventId) return;
    const ref = doc(db, 'events', eventId);
    const unsub = onSnapshot(ref, (snap) => {
      const data = snap.data();
      setUnlocked(!!data?.paywall?.unlocked);
      // Only show anonymous link if unlocked
      setAnonymousLink(data?.paywall?.unlocked ? (data?.anonymousInvitationLink || null) : null);
      setLoading(false);
    });
    return () => unsub();
  }, [eventId]);

  return { unlocked, loading, anonymousLink };
}